import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function ProblemSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      x: -20
    },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section className="bg-dark-200 text-text-dark py-20 md:py-28 px-6" data-id="element-128">
      <div className="max-w-4xl mx-auto space-y-20" data-id="element-129">
        {/* The Problem */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="space-y-6" data-id="element-130">
          <h2 className="text-3xl md:text-4xl font-serif text-accent" data-id="element-131">
            El problema no es tu bebé, ni eres tú.
          </h2>
          <div className="space-y-6 text-lg text-text-dark/80 leading-relaxed" data-id="element-132">
            <p data-id="element-133">
              El problema es que te han vendido dos extremos imposibles: o dejas
              que tu hijo llore hasta el cansancio (rompiendo tu corazón), o te
              resignas a no dormir durante los próximos 3 años.
            </p>
            <p data-id="element-134">
              Este agotamiento crónico está afectando tu salud, tu relación de
              pareja y tu capacidad para estar presente durante el día. La
              privación de sueño es una forma de tortura, y nadie puede ser la
              madre cariñosa que desea ser cuando solo ha dormido 2 horas
              intermitentes.
            </p>
          </div>
        </motion.div>

        {/* Why what you tried didn't work */}
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="bg-dark-100 rounded-2xl p-8 md:p-12 border border-accent/10" data-id="element-135">
          <h3 className="text-2xl md:text-3xl font-serif mb-8 text-center" data-id="element-136">
            Por qué lo que has intentado no funciona
          </h3>

          <ul className="space-y-8" data-id="element-137">
            <motion.li variants={itemVariants} className="flex items-start space-x-4" data-id="element-138">
              <XCircle className="w-6 h-6 text-red-400 shrink-0 mt-1" data-id="element-139" />
              <p className="text-text-dark/80 text-lg" data-id="element-140">
                <strong className="text-text-dark block mb-1" data-id="element-141">
                  Los métodos de "extinción" o dejarlo llorar
                </strong>
                son demasiado fríos para nuestra cultura latina y generan un
                estrés innecesario en la madre.
              </p>
            </motion.li>

            <motion.li variants={itemVariants} className="flex items-start space-x-4" data-id="element-142">
              <XCircle className="w-6 h-6 text-red-400 shrink-0 mt-1" data-id="element-143" />
              <p className="text-text-dark/80 text-lg" data-id="element-144">
                <strong className="text-text-dark block mb-1" data-id="element-145">
                  Los consejos genéricos de "déjalo que se canse más"
                </strong>
                solo logran que el bebé esté sobreestimulado y produzca
                cortisol, dificultando aún más el sueño profundo.
              </p>
            </motion.li>

            <motion.li variants={itemVariants} className="flex items-start space-x-4" data-id="element-146">
              <XCircle className="w-6 h-6 text-red-400 shrink-0 mt-1" data-id="element-147" />
              <p className="text-text-dark/80 text-lg" data-id="element-148">
                <strong className="text-text-dark block mb-1" data-id="element-149">
                  Intervenir al primer gemido
                </strong>
                interrumpe los micro-despertares naturales del bebé,
                impidiéndole aprender la habilidad física de volver a dormirse
                por sí mismo.
              </p>
            </motion.li>
          </ul>
        </motion.div>
      </div>
    </section>;
}